import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');
        
        if (!sessionId) {
          setError('Invalid authentication link');
          toast.error('No session ID found');
          setTimeout(() => navigate('/'), 2000);
          return;
        }
        
        // Exchange session_id for user data
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        });
        
        // Store session token
        localStorage.setItem('session_token', response.data.session_token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        
        toast.success('Successfully logged in!');
        
        // Redirect to gallery
        navigate('/', { replace: true, state: { user: response.data.user } });
      } catch (error) {
        console.error('Auth error:', error);
        setError('Authentication failed');
        toast.error('Authentication failed');
        setTimeout(() => navigate('/'), 2000);
      }
    };
    
    processAuth();
  }, [location, navigate]);
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-[#FAFAFA]">
      <div className="text-center">
        {error ? (
          <div>
            <p className="text-lg mb-4" data-testid="auth-error-text">{error}</p>
            <p className="text-sm text-[#525252]">Redirecting to home...</p>
          </div>
        ) : (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black mx-auto mb-4"></div>
            <p className="text-sm tracking-[0.2em] uppercase" data-testid="auth-processing-text">Processing authentication...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
